<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
  <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>

<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
    <!--begin::Toolbar container-->
    <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <!--begin::Title-->
            <div class="d-flex align-items-center">
                <h1 class="page-heading">
                    <svg width="36" height="33" viewBox="0 0 36 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g filter="url(#filter0_d_667_1492)">
                        <path d="M14.812 15.7043H12.8784C12.6021 15.7043 12.4794 16.0437 12.6635 16.2289L13.1239 16.6917L11.9883 20.1473L12.3566 24.1891H15.2724L15.6715 20.1473L14.6279 16.6917L15.0576 16.2289C15.2111 16.0437 15.0883 15.7043 14.812 15.7043Z" fill="#265D91"/>
                        <path d="M4.62172 18.7588C4.62172 18.7588 4.19202 22.0602 4.00786 23.5103C3.94647 23.8805 4.25341 24.1891 4.62172 24.1891H11.2514L10.8524 19.9313L11.6504 17.8641V14.933L5.32766 17.8332C4.95935 17.9875 4.7138 18.3269 4.62172 18.7588Z" fill="#265D91"/>
                        <path d="M23.6191 23.5104C23.435 22.0603 23.0053 18.7589 23.0053 18.7589C22.9132 18.327 22.6677 17.9876 22.2993 17.8025L15.9766 14.9022V17.679L16.7746 19.9622L16.3449 24.1891H23.0053C23.3736 24.22 23.6498 23.8806 23.6191 23.5104Z" fill="#265D91"/>
                        <path d="M18.1284 10.0582C18.3126 9.13258 18.1591 8.33039 17.7601 8.26868C17.8829 7.31222 17.8829 5.98551 17.2997 5.30674C17.1769 5.15247 17.0235 5.05991 16.87 4.96735C16.7472 4.75137 16.5324 4.35028 16.1027 4.01089C15.4888 3.48637 14.6908 3.23955 13.8314 3.36296C12.9413 3.2704 12.174 3.48637 11.5601 4.01089C11.1304 4.35028 10.9155 4.78223 10.7928 4.96735C10.6393 5.05991 10.4858 5.15247 10.3631 5.30674C9.77989 5.98551 9.81059 7.31222 9.90267 8.26868C9.50366 8.36124 9.35019 9.16343 9.53435 10.0582C9.71851 10.9221 10.1789 11.6009 10.5779 11.57C10.9155 12.7733 11.8977 14.5011 13.8314 14.532C15.7957 14.5011 16.7779 12.7733 17.0848 11.57C17.4839 11.57 17.9443 10.9221 18.1284 10.0582Z" fill="#265D91"/>
                        <path d="M26.4461 11.1381H20.6758C20.461 11.1381 20.2461 11.0147 20.1233 10.8296C20.0006 10.6445 20.0006 10.3977 20.1233 10.1817L21.3817 7.86766C21.0748 7.15803 20.8907 6.35584 20.8907 5.5845C20.8907 2.49914 23.3768 0 26.4461 0C29.5154 0 32.0016 2.49914 32.0016 5.5845C32.0016 8.639 29.4847 11.1381 26.4461 11.1381ZM21.7808 9.84229H26.4461C28.7788 9.84229 30.7124 7.92937 30.7124 5.55364C30.7124 3.17792 28.7788 1.29585 26.4461 1.29585C24.1134 1.29585 22.1798 3.20877 22.1798 5.5845C22.1798 6.29413 22.3639 6.97291 22.6709 7.58998C22.7629 7.7751 22.7629 8.02193 22.6709 8.20705L21.7808 9.84229Z" fill="#265D91"/>
                        <path d="M28.776 5.06002L27.8245 5.98562L28.1007 7.25062C28.1314 7.37403 28.07 7.49745 27.9779 7.55916C27.9166 7.59001 27.8552 7.62086 27.7938 7.62086C27.7324 7.62086 27.7017 7.62086 27.6403 7.59001L26.474 6.94208L25.3077 7.59001C25.2156 7.65172 25.0928 7.65172 25.0007 7.55916C24.9086 7.49745 24.8473 7.37403 24.8779 7.25062L25.1542 5.98562L24.2027 5.06002C24.1106 4.96746 24.0799 4.84404 24.1413 4.72063C24.2027 4.59721 24.2948 4.5355 24.4176 4.5355H25.5839L26.2284 3.42478C26.2898 3.33221 26.3819 3.27051 26.474 3.27051C26.5354 3.27051 26.5661 3.27051 26.6275 3.30136C26.6581 3.33222 26.7195 3.36307 26.7502 3.42478L27.3948 4.5355H28.5611C28.6839 4.5355 28.776 4.59721 28.8374 4.72063C28.868 4.84404 28.868 4.96746 28.776 5.06002Z" fill="#265D91"/>
                        </g>
                        <defs>
                        <filter id="filter0_d_667_1492" x="0" y="0" width="36" height="32.1912" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="4"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_667_1492"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_667_1492" result="shape"/>
                        </filter>
                        </defs>
                        </svg>
                        
                        Nos clients
                </h1>

                <!--begin::Menu-->
              
            </div>
            <!--end::Title-->
            <!--begin::Breadcrumb-->
            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">
                    <a routerLink="/accueil" class="text-muted ">Accueil</a>
                  </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted cursor-pointer" routerLink="/nos-clients">Nos clients</li>
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <li class="breadcrumb-item text-muted">Prestations en cours</li>
                <!--end::Item-->
            </ul>
            <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
    </div>
    <!--end::Toolbar container-->
</div>
<div id="kt_app_content" class="app-content flex-column-fluid mb-4">
    <!--begin::Content container-->
    <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card">
            <!--begin::Card header-->
        
          <div class="card-body">
           <div class="title mb-15">
            <h4>Liste des prestations en cours </h4>
           </div>
          <div class="container-fluid">
            <div class="row mb-3">
                <div class="col-lg-3">
                    <div class="input-group mb-3">
                        <input
                          type="text"
                          data-kt-customer-table-filter="search"
                          [(ngModel)]="searchElement" (keyup.enter)="applyFilter(1); startSearching = true"
                          class="form-control form-control-solid ps-15"
                          placeholder="Rechercher"
                        />
                        <div class="input-group-append">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                              fill="#7E7C7C"
                            />
                          </svg>
            
                          <button
                            class="input-group-text cursor-pointer"
                            id="basic-addon2"
                            (click)="applyFilter(1); startSearching = true"
                          >
                            <span>Rechercher</span>
                          </button>
                        </div>
                      </div>
                </div>
                <div class="col-lg-3 ">
                      
                          </div> 
                          <div class="col-lg-3 ">
                      
                          </div> 
                <div class="col-lg-3">
                  
                   
                </div>
               
            </div>
         
            <div class="table-responsive mt-15">
                <table class="table align-middle fs-6 gy-5 style-table" id="list_cra">
                    <thead>
                        <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                        <th class="min-w-125px">
                            <span>Clients  <i (click)="sortData('name')" class="fa-solid fa-sort"></i></span>
                        </th>
                        <th class="min-w-125px">
                            <span>nombre des consultant en missions  <i (click)="sortData('consultant_count')" class="fa-solid fa-sort"></i></span>
                        </th>
                        <!-- <th class="min-w-125px">
                            <span>nombre de jours de prestations  <i (click)="sortData('nb_days')" class="fa-solid fa-sort"></i></span>
                        </th> -->
                        <th class="min-w-125px">
                            <span>Action</span>
                        </th>
                        </tr>
                    </thead>
                 <tbody>
                    <tr *ngFor="let p of listprestation">
                        <td><a [routerLink]="['/entreprises/details-entreprise',p.company.id]"><span class="first-td">{{p.company.name ? p.company.name  :'---'}}</span></a></td>
                    <td>
                        <span *ngIf="p.company.consultant_count"> {{p.company.consultant_count }} consultants </span>
                        <span *ngIf="!p.company.consultant_count">---</span>
                    </td>
                    <!-- <td>
                        <span *ngIf="p.company.e_s_n_client_final[0].nb_days">{{p.company.e_s_n_client_final[0].nb_days }} jours </span>
                        <span *ngIf="!p.company.e_s_n_client_final[0].nb_days">---</span>
                    </td> -->
                    <td>
                        <a [routerLink]="['/entreprises/details-entreprise',p.company.id]" class="voir">Voir plus</a>
                    </td>
                    </tr>
                 
                  
                 
                 </tbody>
    
                </table>
             </div>
           
             <div class="alert alert-warning text-center mt-5" role="alert"
             *ngIf="listprestation && !listprestation.length">
             <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
             <span class="empty-list">
                 La liste est vide
             </span>
           </div>
          </div>
         
           
<div class="pagination" *ngIf="listprestation && listprestation.length">
  <app-pagination [data]="listprestation"  [currentPageList]="currentPage" [endexPageList]="endIndex" [lengthData]="totalItems" (setPages)="getItems($event)"> </app-pagination>
</div>


          </div>
        </div>
     
    </div>
    <!--end::Content container-->
</div>
